<template>
  <RouterView />
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import Cookie from 'js-cookie';
import { Language } from '@/services';
import { GENERAL_MODULE, EMPLOYEE_MODULE } from '@/constants/modules';

export default {
  name: 'SignUpView',
  created() {
    this.setLocales();
    this.setOperatorsByCountries();
    this.setUbeeqoTitles();
    this.checkIfResetStore();
    localStorage.removeItem('authData');
    Cookie.remove('authData');
  },
  async mounted() {
    this.$segments.trackAnonymousUser();
    this.$segments.visitPage('Company Signup');
  },
  methods: {
    ...mapActions(GENERAL_MODULE, [
      'setOperatorsByCountries',
      'setUbeeqoTitles',
    ]),
    ...mapMutations(GENERAL_MODULE, ['locale']),
    ...mapMutations(EMPLOYEE_MODULE, ['resetUser']),
    checkIfResetStore() {
      const lastEnter = localStorage.getItem('last-entered');
      const currentDate = moment().format();
      const resetStorage = moment(currentDate).diff(moment(lastEnter), 'minutes') >= 5; // 5 minutes
      if (!lastEnter || !resetStorage) {
        localStorage.setItem('last-entered', currentDate);
      }

      if (resetStorage) {
        this.resetUser();
        localStorage.setItem('last-entered', currentDate);
      }
    },
    setLocales() {
      this.locale(Language.getInstance().getLanguage());
    },
  },
};
</script>
